import { createContext, useContext } from 'react';

import { INITIAL_MEMBER, IMemberContext } from './member.context.model';

export const MemberContext = createContext<IMemberContext>(INITIAL_MEMBER);

export const useCurrentMemberContext = () => useContext(MemberContext);
